import React from "react";
import SkillPill from "../../../components/SkillPill/SkillPill";

export default function RightInfoPanel({ artifactDetails, skillsData, userName, firstName }) {

  const areas = artifactDetails?.student_selected_skills?.map((area) => area.title) || [];
  const commentsSortedByDateTime = artifactDetails?.comments && artifactDetails.comments.length > 0
    ? [...artifactDetails.comments].sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    : [];
  const firstComment = commentsSortedByDateTime[0] || null;
  const isFirstCommentByLearner = firstComment?.user.role === "ROLE_LEARNER";
  
  return (
    <div className="mt-[46px] max-w-[690px]">
      <div className="grid grid-cols-2 gap-x-8 gap-y-4 mb-4 items-baseline">
        <div className="flex flex-row items-center gap-1">
          <div className="text-base font-semibold">Learner:</div>
          <div className="text-sm">{userName}</div>
        </div>
        <div className="flex flex-row items-center gap-1 items-baseline text-wrap">
          <div className="text-base font-semibold">Title:</div>
          <div className="text-sm break-words overflow-hidden">{artifactDetails?.title}</div>
        </div>
        <div className="flex flex-row items-center gap-1 items-baseline">
          <div className="text-base font-semibold">Group Experience:</div>
          <div className="text-sm">{artifactDetails?.isGroupExperience ? "Yes" : "No"}</div>
        </div>
        <div className="flex flex-row items-center gap-1 items-baseline">
          <div className="text-base font-semibold">Artifact Type:</div>
          <div className="text-sm">{artifactDetails?.type}</div>
        </div>
      </div>

      <div className="flex flex-row gap-1 mt-[25px] items-baseline">
        <div className="text-base font-semibold text-nowrap">Description:</div>
        <div className="text-sm break-words overflow-hidden">
          {artifactDetails?.description}
        </div>
      </div>

      <div className="flex flex-row gap-1 mt-[37px] items-baseline">
        <div className="text-base font-semibold text-nowrap">
          {`${firstName}'s Reflection:`}
        </div>
        <div className="text-sm break-words overflow-hidden">
          {firstComment && isFirstCommentByLearner
            ? firstComment.text
            : "No reflection available."}
        </div>
      </div>

      <div className="mb-4 mt-[36px]">
        <div className="text-base  font-base">
          Skills Identified by the Learner
        </div>
        <div className="mt-2 p-3 border border-[#A7ADB1] rounded-lg bg-white">
          <SkillPill
            skills={areas.length > 0 ? areas : []} message="Student did not select any skills."
          />
        </div>
      </div>

      {/* <div>Artifact ID: {artifactData}</div>
      <div>Skills Data: {JSON.stringify(skillsData)}</div> */}
    </div>
  );
}